import { createContext } from 'react'

export interface WindowOpenOpts {
  pinned?: boolean
  size?: { w: number; h: number }
  position?: { x: number; y: number }
}

export interface WindowState {
  id: string
  title: string
  route: string
  position: { x: number; y: number }
  size: { w: number; h: number }
  minimized: boolean
  maximized: boolean
  zIndex: number
  pinned?: boolean
  prevBounds?: { x: number; y: number; w: number; h: number }
}

export interface WindowManagerContextType {
  windows: WindowState[]
  openWindow: (route: string, title: string, opts?: WindowOpenOpts) => boolean
  closeWindow: (id: string) => void
  focusWindow: (id: string) => void
  minimizeWindow: (id: string) => void
  maximizeWindow: (id: string) => void
  restoreWindow: (id: string) => void
  moveWindow: (id: string, pos: { x: number; y: number }) => void
  resizeWindow: (id: string, size: { w: number; h: number }) => void
  closeAll: () => void
  maxReached: boolean
}

export const WindowManagerContext = createContext<WindowManagerContextType | null>(null)
